(function () {
  function init(root) {
    if (root.getAttribute('data-fg-ready')) return;
    root.setAttribute('data-fg-ready', 'true');

    var ENDPOINT = root.getAttribute('data-endpoint');
    var USE_CAPTCHA = root.getAttribute('data-use-captcha') === 'true';

    var form = root.querySelector('[data-fg-form]');
    var button = root.querySelector('[data-fg-submit]');
    var formError = root.querySelector('[data-fg-form-error]');
    var terms = root.querySelector('[data-fg-terms]');
    var termsWrap = root.querySelector('[data-fg-terms-wrap]');
    var success = root.querySelector('[data-fg-success]');
    var tooltipToggle = root.querySelector('[data-fg-tooltip-toggle]');
    var tooltip = root.querySelector('[data-fg-tooltip]');

    var inputs = {
      first_name: root.querySelector('[data-fg-input="first_name"]'),
      last_name: root.querySelector('[data-fg-input="last_name"]'),
      email: root.querySelector('[data-fg-input="email"]')
    };
    var messages = {
      first_name: 'Please enter your first name.',
      last_name: 'Please enter your last name.',
      email: 'Please enter a valid email address.'
    };
    var touched = {};
    var captchaOk = !USE_CAPTCHA;
    var submitting = false;

    function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

    function fieldValid(name) {
      var v = inputs[name].value.trim();
      return name === 'email' ? isEmail(v) : v.length > 0;
    }

    function showFieldState(name) {
      var wrap = inputs[name].closest('[data-fg-field]');
      var err = wrap.querySelector('[data-fg-error]');
      var bad = !!touched[name] && !fieldValid(name);
      wrap.classList.toggle('is-invalid', bad);
      err.textContent = bad ? messages[name] : '';
    }

    function allValid() {
      return fieldValid('first_name') && fieldValid('last_name') && fieldValid('email') && terms.checked && captchaOk;
    }

    function refresh() { button.disabled = submitting || !allValid(); }

    Object.keys(inputs).forEach(function (name) {
      var el = inputs[name];
      el.addEventListener('input', function () {
        if (touched[name]) showFieldState(name);
        refresh();
      });
      el.addEventListener('blur', function () {
        touched[name] = true;
        showFieldState(name);
        refresh();
      });
    });

    terms.addEventListener('change', function () {
      termsWrap.classList.toggle('is-invalid', !terms.checked);
      refresh();
    });

    // reCAPTCHA callbacks (named in the widget's data-callback attributes)
    window.fgOnRecaptchaSuccess = function () { captchaOk = true; refresh(); };
    window.fgOnRecaptchaExpired = function () { captchaOk = false; refresh(); };

    if (tooltipToggle && tooltip) {
      tooltipToggle.addEventListener('click', function (e) {
        e.preventDefault();
        var opening = tooltip.hasAttribute('hidden');
        if (opening) { tooltip.removeAttribute('hidden'); } else { tooltip.setAttribute('hidden', ''); }
        tooltipToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      });
    }

    function resetCaptcha() {
      if (!USE_CAPTCHA) return;
      captchaOk = false;
      if (window.grecaptcha && typeof window.grecaptcha.reset === 'function') window.grecaptcha.reset();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitting) return;

      Object.keys(inputs).forEach(function (name) {
        touched[name] = true;
        showFieldState(name);
      });
      termsWrap.classList.toggle('is-invalid', !terms.checked);
      if (!allValid()) { refresh(); return; }

      submitting = true;
      formError.hidden = true;
      refresh();

      // Matches the payload captured from the current site.
      // Phone is intentionally NOT sent (the current site ignores it too).

  // "emailAddress": "string",
  // "firstName": "string",
  // "lastName": "string",
  // "country": "string",
  // "phoneNumber": "string",
  // "subscriptionType": "string"
      var payload = {
        firstName: inputs.first_name.value.trim(),
        lastName: inputs.last_name.value.trim(),
        emailAddress: inputs.email.value.trim()
      };

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          root.setAttribute('data-state', 'success');
          resetCaptcha();
          success.focus();
          if (success.scrollIntoView) success.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function (err) {
          if (window.console) console.error('Free gift submission failed:', err);
          formError.hidden = false;
          resetCaptcha();
        })
        .then(function () {
          submitting = false;
          refresh();
        });
    });

    window.addEventListener('load', refresh);
    refresh();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-fg-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();